import { writable } from 'svelte/store';
const globalState = {
    playerLoaded: false,
    overlayLoaded: false,
    aspectRatio: 1.778,
    slot: null,
    slotID: '',
    superFrameContainer: null,
    fitContainer: true,
    center: true,
    isPreview: false,
    banner: false,
    video: true,
};
const bannerState = {
    width: 300,
    height: 250,
};
const videoState = {
    videoElement: null,
    videos: [],
    controlsOver: false,
    videoAutoPlay: true,
    videoMuted: false, // mute the video on load
};
export const globalStore = writable(globalState);
export const bannerStore = writable(bannerState);
export const videoStore = writable(videoState);
export const slotStore = writable({ height: 0, width: 0 });
export const resetStores = () => {
    // console.debug('cleaning stores')
    globalStore.set(globalState);
    bannerStore.set(bannerState);
    videoStore.set(videoState);
    slotStore.set({ height: 0, width: 0 });
};
